import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=4bf78237"
import script from "./quillEditor.vue?vue&type=script&lang=js"
export * from "./quillEditor.vue?vue&type=script&lang=js"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=4bf78237&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_8f028cf8807308e2a605e975797e53c7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports